/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { lazy, object, Schema } from '../schema';
import { Data6, data6Schema } from './data6';
import { Links, linksSchema } from './links';
import { Meta, metaSchema } from './meta';

export interface AC115Retrieveaccountoffers {
  data: Data6;
  links: Links;
  meta: Meta;
}

export const aC115RetrieveaccountoffersSchema: Schema<AC115Retrieveaccountoffers> = object(
  {
    data: ['Data', lazy(() => data6Schema)],
    links: ['Links', lazy(() => linksSchema)],
    meta: ['Meta', lazy(() => metaSchema)],
  }
);
